var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 92,
    viewBox: "0 0 98 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8048 33.8159C29.1254 33.8159 36.6812 26.2459 36.6812 16.9079C36.6812 7.56994 29.1254 0 19.8048 0C10.4843 0 2.92847 7.56994 2.92847 16.9079C2.92847 26.2459 10.4843 33.8159 19.8048 33.8159Z",
    fill: "#E33AA9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7184 33.8159C87.0389 33.8159 94.5947 26.2459 94.5947 16.9079C94.5947 7.56994 87.0389 0 77.7184 0C68.3978 0 60.842 7.56994 60.842 16.9079C60.842 26.2459 68.3978 33.8159 77.7184 33.8159Z",
    fill: "#E33AA9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 63.3418C0 63.3418 43.9298 83.6607 98 63.3418C98 63.3418 87.3836 91.8762 51.6541 91.8762C15.9245 91.8762 0 63.3418 0 63.3418Z",
    fill: "#E33AA9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFace);
export default __webpack_public_path__ + "static/media/face.d892afdc6b2c0586f4f4fc3f43945ea8.svg";
export { ForwardRef as ReactComponent };